import React from 'react';
import { EditableComponent } from '@adobe/aem-react-editable-components';

import { OMediaCaption as OMediaCaptionComp } from '@marriott/mi-web-ui-kit';
import clsx from 'clsx';

export const OMediaCaptionConfig = {
  emptyLabel: 'OMediaCaption',
  isEmpty: () => true,
  resourceType: `${process.env['NEXT_PUBLIC_AEM_SITE']}/components/content/o-media-caption`,
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const OMediaCaption = (props: any) => {
  const model = props.model || {};
  const { styleclass, componentId } = model;

  return (
    <div
      data-testid="o-media-caption-comp"
      data-component-name="o-media-caption"
      id={componentId}
      className={clsx(styleclass)}
    >
      <EditableComponent config={OMediaCaptionConfig} {...props}>
        <OMediaCaptionComp {...props} />
      </EditableComponent>
    </div>
  );
};
